import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortAlphabeticallyPipe } from './sort-alphabetically.pipe';
import { SortByLanguagePipe } from './sort-by-language.pipe';
import { FilterDataPipe } from './filter-data.pipe';
import { FilterLogPipe } from './filter-log.pipe';
import { FilterItemByCategoryPipe } from './filter_item_by_category.pipe';

const pipes = [
  SortAlphabeticallyPipe,
  SortByLanguagePipe,
  FilterDataPipe,
  FilterLogPipe,
  FilterItemByCategoryPipe,
];
@NgModule({
  imports: [CommonModule],
  declarations: pipes,
  exports: pipes,
  providers: pipes,
})
export class CustomPipeModule {}
